module.exports = __webpack_public_path__ + "img/tla.e744257c.svg";